export const OHL = {
    name: 'DV 263A TS OBRENOVAC - TENT A (od G-3)',
    voltage: '220',
    regionCode: 'BGD',
    stanice: [{name: 'OBRENOVAC', position: {lat: 44.6651, lng: 20.1688}}],
    stubovi: [
        { index: 1, name: 'P-14', lat: 44.666 , lng: 20.1686, sys: 1, portal: true  },
        { index: 2, name: '1', lat: 44.6669 , lng: 20.1682, sys: 2 },
        { index: 3, name: '2', lat: 44.6686 , lng: 20.1676, sys: 2 },
        { index: 4, name: '3', lat: 44.6695 , lng: 20.165, sys: 2 },
        { index: 5, name: '4', lat: 44.6706 , lng: 20.1621, sys: 2  }
    ],
    rasponi: [
        { name: 'P-14 - 1', position: [{ lat: 44.666 , lng: 20.1686 }, { lat: 44.6669 , lng: 20.1682 }] },
        { name: '1 - 2', position: [{ lat: 44.6669 , lng: 20.1682 }, { lat: 44.6686 , lng: 20.1676 }] },
        { name: '2 - 3', position: [{ lat: 44.6686 , lng: 20.1676 }, { lat: 44.6695 , lng: 20.165 }] },
        { name: '3 - 4', position: [{ lat: 44.6695 , lng: 20.165 }, { lat: 44.6706 , lng: 20.1621 }] }
    ]
}
